import { Input } from '../../ui';
import { useFieldContext } from '../FieldContext';

/**
 * DATETIME is stored as an ISO instant with an offset. The control edits UTC and
 * the display renders UTC, so what is typed is what is stored - a
 * browser-timezone conversion in one direction only is how "the call moved by two
 * hours" bugs happen.
 */
export function DateTimeInput() {
  const { field, value, onChange, readOnly } = useFieldContext();
  return (
    <Input
      type="datetime-local"
      value={typeof value === 'string' ? value.slice(0, 16) : ''}
      onChange={(event) =>
        onChange(event.target.value === '' ? null : `${event.target.value}:00.000Z`)
      }
      disabled={readOnly}
      aria-label={`${field.label} (UTC)`}
    />
  );
}
